/* @flow */

export const dialogElevation = 24;
export const navDrawerElevation = 16;
export const notificationElevation = 10;
export const bottomAppBarElevation = 8;
export const bottomNavBarElevation = 8;
export const navTabElevation = 7;
export const secondaryNotificationElevation = 6;
export const topAppBarElevation = 4;
export const sidebarElevation = 1;

export const boxShadow = '0 0 3px 0 rgba(0, 0, 0, 0.5)';
